var _style, _circle, _circle2, _circle3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.61,
    height: 185.61,
    viewBox: "0 0 185.61 185.61"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#012846}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 92.8 92.8)",
    cx: 92.8,
    cy: 92.8,
    fill: "#ef3e31",
    r: 92.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 55.24,
    cy: 85.03,
    r: 8.79
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.36,
    cy: 85.03,
    r: 8.79
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 92.8,
    cy: 136.07,
    rx: 20.17,
    ry: 28.7
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODUuNjEiIGhlaWdodD0iMTg1LjYxIiB2aWV3Qm94PSIwIDAgMTg1LjYxIDE4NS42MSI+PHN0eWxlPi5zdDF7ZmlsbDojMDEyODQ2fTwvc3R5bGU+PGNpcmNsZSB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgOTIuOCA5Mi44KSIgY3g9IjkyLjgiIGN5PSI5Mi44IiBmaWxsPSIjZWYzZTMxIiByPSI5Mi44Ii8+PGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iNTUuMjQiIGN5PSI4NS4wMyIgcj0iOC43OSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjEzMC4zNiIgY3k9Ijg1LjAzIiByPSI4Ljc5Ii8+PGVsbGlwc2UgY2xhc3M9InN0MSIgY3g9IjkyLjgiIGN5PSIxMzYuMDciIHJ4PSIyMC4xNyIgcnk9IjI4LjciLz48L3N2Zz4=";
export { SvgNote6 as ReactComponent };